(function(){

function hiScrollToResultTop(){
  const target = document.getElementById('resultHeading') || document.getElementById('results');
  if(!target) return;
  const y = target.getBoundingClientRect().top + window.pageYOffset - 160;
  window.scrollTo({ top: y, behavior: 'smooth' });
}

  const config=window.HI_SUPPORT_CONFIG||{};
  const warrantyTo=config.warrantyEmail||'jessicaf@highlightindustries.com';
  const machinesCsvUrl=config.machinesCsvUrl||'https://highlight-industries.github.io/Highlight-Support-Center-Data/support-center-machines.csv';
  const csaCsvUrl=config.csaCsvUrl||'https://highlight-industries.github.io/Highlight-Support-Center-Data/csa-machines.csv';
  const manualRulesCsvUrl=config.manualRulesCsvUrl||'https://highlight-industries.github.io/Highlight-Support-Center-Data/manual-rules.csv';

  let supportRecords=window.HI_SUPPORT_RECORDS||[];
  let manualRules=[];
  let csaJobs=new Set();
  let dataPromise=null;
  let csvLoadErrors=[];
  let currentWarrantyRecord=null, currentWarrantyLabel='', lastLookupKey='';

  function clean(v){ return String(v||'').trim(); }
  function digits(v){ return clean(v).replace(/\D/g,''); }
  function upper(v){ return clean(v).toUpperCase(); }
  function truthy(v){ return ['1','TRUE','YES','Y','X'].includes(upper(v)); }
  function normalizeDate(value){
    const v=clean(value);
    if(!v) return '';
    if(/^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
    let m=v.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})$/);
    if(m){
      let y=Number(m[3]);
      if(y<100) y+= y>=70 ? 1900 : 2000;
      return String(y).padStart(4,'0')+'-'+String(Number(m[1])).padStart(2,'0')+'-'+String(Number(m[2])).padStart(2,'0');
    }
    m=v.match(/^(\d{1,2})-([A-Za-z]{3})-(\d{2}|\d{4})$/);
    if(m){
      const months={JAN:'01',FEB:'02',MAR:'03',APR:'04',MAY:'05',JUN:'06',JUL:'07',AUG:'08',SEP:'09',OCT:'10',NOV:'11',DEC:'12'};
      let y=Number(m[3]);
      if(y<100) y+= y>=70 ? 1900 : 2000;
      const mon=months[m[2].toUpperCase()];
      if(mon) return String(y).padStart(4,'0')+'-'+mon+'-'+String(Number(m[1])).padStart(2,'0');
    }
    return v;
  }
  function dateOk(value,start,end){
    const d=normalizeDate(value);
    start=normalizeDate(start);
    end=normalizeDate(end);
    if(start && d < start) return false;
    if(end && d > end) return false;
    return true;
  }
  function contains(hay,needle){
    if(!clean(needle)) return true;
    return upper(hay).includes(upper(needle));
  }

  function parseCSV(text){
    text=String(text||'').replace(/^\uFEFF/,'');
    const rows=[];
    let row=[], field='', inQuotes=false;
    for(let i=0;i<text.length;i++){
      const c=text[i], n=text[i+1];
      if(inQuotes){
        if(c === '"' && n === '"'){ field+='"'; i++; }
        else if(c === '"'){ inQuotes=false; }
        else { field+=c; }
      }else{
        if(c === '"') inQuotes=true;
        else if(c === ','){ row.push(field); field=''; }
        else if(c === '\n'){ row.push(field); rows.push(row); row=[]; field=''; }
        else if(c !== '\r'){ field+=c; }
      }
    }
    row.push(field);
    rows.push(row);
    if(!rows.length) return [];
    const headers=rows.shift().map(h=>clean(h));
    return rows
      .filter(r=>r.some(c=>clean(c)))
      .map(r=>{
        const obj={};
        headers.forEach((h,i)=>{ obj[h]=clean(r[i]); });
        return obj;
      });
  }

  async function fetchCSV(url){
    if(!url) return [];
    const res=await fetch(url,{cache:'no-store'});
    if(!res.ok) throw new Error('Could not load CSV: '+url+' ('+res.status+')');
    return parseCSV(await res.text());
  }

  function normalizeMachineRow(row){
    return {
      so: clean(row.SalesOrder || row['Sales Order'] || row['Sales Order Number']),
      job: clean(row.JobNumber || row.Job || row['Job#'] || row.MCJ),
      po: clean(row.PO || row['PO#']),
      customer: clean(row.Customer),
      customerPO: clean(row.CustomerPO || row['Customer PO']),
      m: upper(row.MachineModel || row.Model),
      s: upper(row.MachineStyle || row.Style),
      t: upper(row.MachineType || row.Type),
      d: normalizeDate(row.MachineDate || row['Assembly Date'] || row.Date),
      shipDate: clean(row.ShipDate || row['Ship Date'])
    };
  }

  function normalizeRule(row){
    return {
      name: clean(row.RuleName),
      active: !row.Active || truthy(row.Active),
      type: upper(row.RuleType || 'manual').toLowerCase(),
      model: upper(row.MachineModel),
      style: upper(row.MachineStyle),
      typeContains: upper(row.MachineTypeContains),
      csaOnly: clean(row.CSAOnly),
      customerContains: upper(row.CustomerContains),
      scaleOnly: clean(row.ScaleOnly),
      start: normalizeDate(row.StartDate),
      end: normalizeDate(row.EndDate),
      title: clean(row.ManualTitle),
      url: clean(row.ManualUrl),
      noManualMessage: clean(row.NoManualMessage),
      notes: clean(row.Notes)
    };
  }

  async function loadData(){
    if(dataPromise) return dataPromise;
    dataPromise=Promise.allSettled([
      fetchCSV(machinesCsvUrl),
      fetchCSV(csaCsvUrl),
      fetchCSV(manualRulesCsvUrl)
    ]).then(results=>{
      csvLoadErrors=[];
      if(results[0].status==='fulfilled'){
        supportRecords=results[0].value.map(normalizeMachineRow).filter(r=>r.job||r.so||r.po);
      } else { csvLoadErrors.push('machine CSV'); }
      if(results[1].status==='fulfilled'){
        csaJobs=new Set(results[1].value.map(r=>digits(r.JobNumber||r.Job||r.MCJ)).filter(Boolean));
      } else { csvLoadErrors.push('CSA CSV'); }
      if(results[2].status==='fulfilled'){
        manualRules=results[2].value.map(normalizeRule).filter(r=>r.active);
      } else { csvLoadErrors.push('manual rules CSV'); }
      console.log('Support Center CSV loaded:', {
        machines:supportRecords.length,
        csaJobs:csaJobs.size,
        rules:manualRules.length,
        errors:csvLoadErrors
      });
      return {supportRecords,csaJobs,manualRules};
    }).catch(err=>{
      console.error('Support Center CSV load error:',err);
      return {supportRecords,csaJobs,manualRules};
    });
    return dataPromise;
  }

  function findSupportRecord(key){
    const k=digits(key);
    return supportRecords.find(r=>digits(r.job)===k || digits(r.so)===k || digits(r.po)===k || digits(r.customerPO)===k) || null;
  }

  function machineLabel(r){
    const model=r.m||'', style=r.s||'', type=r.t||'';
    if(model==='CAS'&&style==='2300'&&type.includes('SDU')) return 'Magnum 2300 SD-U';
    if(model==='PREDATOR'&&style==='SS') return 'Predator SS '+type.trim();
    if(model==='PREDATOR'&&style==='XS') return 'Predator XS '+type.trim();
    if(model==='PREDATOR'&&style==='UX') return 'Predator UX Turntable';
    if(model==='SYN'&&style==='.5') return 'Synergy 0.5 '+type.trim();
    if(model==='SYN'&&style==='HP'&&type==='TT') return 'High Profile Turntable';
    return [model,style,type].filter(Boolean).join(' ');
  }

  function rulePriority(rule){
    let score=0;
    if(rule.csaOnly==='1') score+=1000;
    if(rule.customerContains) score+=700;
    if(rule.scaleOnly==='1') score+=500;
    if(rule.type==='no_manual') score+=300;
    if(rule.model) score+=40;
    if(rule.style) score+=30;
    if(rule.typeContains) score+=20;
    return score;
  }
  function ruleStartNumber(rule){
    return Number((rule.start||'').replace(/\D/g,''))||0;
  }

  function machineHasScale(r){
    const hay=[r.t,r.s,r.m,r.customer,r.customerPO,r.po].join(' ').toUpperCase();
    return hay.includes('SCALE');
  }

  function ruleMatches(rule,r,isCSA){
    if(rule.model && rule.model!==r.m) return false;
    if(rule.style && rule.style!==r.s) return false;
    if(rule.typeContains && !contains(r.t,rule.typeContains)) return false;
    if(rule.customerContains && !contains(r.customer,rule.customerContains)) return false;
    if(rule.csaOnly==='1' && !isCSA) return false;
    if(rule.csaOnly==='0' && isCSA) return false;
    if(rule.scaleOnly==='1' && !machineHasScale(r)) return false;
    if(!dateOk(r.d,rule.start,rule.end)) return false;
    return true;
  }

  function extraFromRule(rule){
    return {title:rule.title||rule.name,url:rule.url,note:rule.notes||''};
  }

  function fallbackManualFromRecord(r,isCSA,addons){
    if(isCSA){
      return {
        title:'CSA/CUL manual support review needed',
        url:'',
        note:'This MCJ/job number appears on the CSA/CUL list, but no verified CSA/CUL manual rule matched this machine/date. Contact Parts Support to confirm the correct manual.',
        status:'warn',
        extras:addons||[]
      };
    }

    if(r.m==='PREDATOR' && r.s==='SS'){
      if(dateOk(r.d,'2025-08-01','')){
        return {
          title:'Predator SS Standard Manual 2025',
          url:'https://cdn.shopify.com/s/files/1/0848/7206/9402/files/predator-ss-standard-2025.pdf?v=1780230423',
          note:'Predator SS standard fallback matched.',
          status:'ok',
          extras:addons||[]
        };
      }
      if(r.t==='LP' && dateOk(r.d,'2024-11-25','2025-07-31')){
        return {
          title:'2024 Predator SS HP and LP Manual',
          url:'https://cdn.shopify.com/s/files/1/0848/7206/9402/files/2024_-_Predator_SS_HP_and_LP_Manual.pdf?v=1780412861',
          note:'Predator SS LP 2024 fallback matched.',
          status:'ok',
          extras:addons||[]
        };
      }
    }

    if(r.m==='PREDATOR' && r.s==='XS'){
      if((r.t||'').includes('SCALE') && dateOk(r.d,'2025-11-14','')){
        return {
          title:'Predator XS Scale 2025',
          url:'https://cdn.shopify.com/s/files/1/0848/7206/9402/files/predator-xs-scale-2025-rev-c.pdf?v=1780230424',
          note:'Predator XS scale fallback matched.',
          status:'ok',
          extras:addons||[]
        };
      }
      if((r.t||'').includes('SCALE') && dateOk(r.d,'2025-01-15','2025-11-13')){
        return {
          title:'Predator XS Scale Manual Review Needed',
          url:'',
          note:'Predator XS with Scale records from 01/15/2025 to 11/13/2025 should route to Parts Support for manual review.',
          status:'warn',
          extras:addons||[]
        };
      }
      if(dateOk(r.d,'2025-11-14','')){
        return {
          title:'Predator XS Standard Manual 2025 REV D',
          url:'https://cdn.shopify.com/s/files/1/0848/7206/9402/files/predator-xs-standard-2025-rev-d.pdf?v=1780230424',
          note:'Predator XS REV D fallback matched.',
          status:'ok',
          extras:addons||[]
        };
      }
      if(dateOk(r.d,'2025-08-27','2025-11-13')){
        return {
          title:'Predator XS 830 PLC Sesame Manual REV B',
          url:'https://cdn.shopify.com/s/files/1/0848/7206/9402/files/2025_Predator_XS_830_PLC_Sesame_Manual_REV_B.pdf?v=1780413336',
          note:'Predator XS REV B fallback matched.',
          status:'ok',
          extras:addons||[]
        };
      }
      if(dateOk(r.d,'2025-06-27','2025-08-26')){
        return {
          title:'Predator XS 830 PLC Sesame Manual REV A',
          url:'https://cdn.shopify.com/s/files/1/0848/7206/9402/files/2025_Predator_XS_830_PLC_Sesame_Manual_REV_A.pdf?v=1780413238',
          note:'Predator XS REV A fallback matched.',
          status:'ok',
          extras:addons||[]
        };
      }
      if(dateOk(r.d,'2025-01-15','2025-06-26')){
        return {
          title:'Predator XS 830 PLC Sesame Manual',
          url:'https://cdn.shopify.com/s/files/1/0848/7206/9402/files/2025_Predator_XS_830_PLC_Sesame_Manual.pdf?v=1780413433',
          note:'Predator XS no-REV fallback matched.',
          status:'ok',
          extras:addons||[]
        };
      }
    }

    if(r.m==='CAS' && r.s==='2300' && (r.t||'').includes('SDU') && dateOk(r.d,'2023-05-08','')){
      return {
        title:'Magnum 2300 SD-U Manual 2023',
        url:'https://cdn.shopify.com/s/files/1/0848/7206/9402/files/magnum-2300-sdu-2023.pdf?v=1780230422',
        note:'Magnum 2300 SD-U fallback matched.',
        status:'ok',
        extras:addons||[]
      };
    }

    return null;
  }

  function noManualSpecificity(rule){
    let score=0;
    if(rule.csaOnly==='1' || rule.csaOnly==='0') score+=1000;
    if(rule.customerContains) score+=700;
    if(rule.scaleOnly==='1') score+=500;
    if(rule.model) score+=80;
    if(rule.style) score+=60;
    if(rule.typeContains) score+=40;
    return score;
  }


  function matchManual(r){
    const isCSA=csaJobs.has(digits(r.job));
    const matching=manualRules
      .filter(rule=>ruleMatches(rule,r,isCSA))
      .sort((a,b)=>rulePriority(b)-rulePriority(a) || ruleStartNumber(b)-ruleStartNumber(a));

    const addons=matching
      .filter(rule=>rule.type==='addon' && rule.url)
      .map(extraFromRule);

    const manualMatches=matching
      .filter(rule=>rule.type==='manual' && rule.url)
      .sort((a,b)=>rulePriority(b)-rulePriority(a) || ruleStartNumber(b)-ruleStartNumber(a));

    const noManualMatches=matching
      .filter(rule=>rule.type==='no_manual')
      .sort((a,b)=>noManualSpecificity(b)-noManualSpecificity(a) || ruleStartNumber(b)-ruleStartNumber(a));

    if(isCSA){
      const csaManual=manualMatches.find(rule=>rule.csaOnly==='1');
      if(csaManual){
        return {
          title:csaManual.title||csaManual.name,
          url:csaManual.url,
          note:csaManual.notes || 'CSA/CUL manual rule matched from the CSA MCJ/job list.',
          status:'ok',
          extras:addons
        };
      }
      const specificNoManual=noManualMatches.find(rule=>noManualSpecificity(rule)>0);
      if(specificNoManual){
        return {
          title:specificNoManual.title||'CSA/CUL manual support review needed',
          url:'',
          note:specificNoManual.noManualMessage||specificNoManual.notes||'This CSA/CUL machine/date should route to Parts Support for manual review.',
          status:'warn',
          extras:addons
        };
      }
      return {
        title:'CSA/CUL manual support review needed',
        url:'',
        note:'This MCJ/job number appears on the CSA/CUL list, but no verified CSA/CUL manual rule matched this machine/date. Contact Parts Support to confirm the correct manual.',
        status:'warn',
        extras:addons
      };
    }

    const bestManual=manualMatches[0];
    const specificNoManual=noManualMatches.find(rule=>noManualSpecificity(rule)>0);

    if(specificNoManual && (!bestManual || noManualSpecificity(specificNoManual) >= rulePriority(bestManual))){
      return {
        title:specificNoManual.title||'Manual support review needed',
        url:'',
        note:specificNoManual.noManualMessage||specificNoManual.notes||'This machine/date should route to Parts Support for manual review.',
        status:'warn',
        extras:addons
      };
    }

    if(bestManual){
      return {
        title:bestManual.title||bestManual.name,
        url:bestManual.url,
        note:bestManual.notes || 'Manual rule matched from the support-center manual rules.',
        status:'ok',
        extras:addons
      };
    }

    const fallback=fallbackManualFromRecord(r,isCSA,addons);
    if(fallback) return fallback;

    const catchAll=noManualMatches.find(rule=>noManualSpecificity(rule)===0);
    if(catchAll){
      return {
        title:catchAll.title||'Manual support review needed',
        url:'',
        note:catchAll.noManualMessage||catchAll.notes||'A machine record was found, but no verified manual rule matched this machine/date. Contact Parts Support to confirm the correct document.',
        status:'warn',
        extras:addons
      };
    }

    return {
      title:'Manual support review needed',
      url:'',
      note:'A machine record was found, but no verified manual rule matched this machine/date. Contact Parts Support to confirm the correct document.',
      status:'warn',
      extras:addons
    };
  }

  const form=document.getElementById('lookupForm'),
    input=document.getElementById('lookupInput'),
    empty=document.getElementById('emptyState'),
    result=document.getElementById('resultState'),
    notFound=document.getElementById('notFoundState'),
    sticky=document.getElementById('stickyResult'),
    loader=document.getElementById('lookupLoader'),
    curtain=document.getElementById('transitionCurtain');

  function hideStates(){ [empty,result,notFound].forEach(x=>x&&x.classList.remove('show')); }
  function show(el){ if(loader){loader.classList.remove('show'); loader.setAttribute('aria-hidden','true');} hideStates(); if(el) el.classList.add('show'); }
  function resetCurtain(){
    if(curtain){ curtain.className='transition-curtain'; curtain.setAttribute('aria-hidden','true'); }
    document.body.classList.remove('support-is-loading');
  }
  function beginLookup(done){
    hideStates();
    if(sticky) sticky.classList.remove('show');
    if(loader){ loader.classList.add('show'); loader.setAttribute('aria-hidden','false'); }
    document.body.classList.add('support-is-loading');

    if(!curtain){ done(); return; }
    curtain.className='transition-curtain active';
    curtain.setAttribute('aria-hidden','false');
    void curtain.offsetWidth;
    requestAnimationFrame(()=>curtain.classList.add('closing'));

    window.setTimeout(()=>{ curtain.classList.remove('closing'); curtain.classList.add('closed'); done(); },1450);
    window.setTimeout(()=>{ curtain.classList.remove('closed'); curtain.classList.add('opening'); },3100);
    window.setTimeout(resetCurtain,5000);
  }

  function openWarranty(){
    if(!currentWarrantyRecord) return;
    const r=currentWarrantyRecord;
    document.getElementById('wSerialInput').value=r.job||'';
    document.getElementById('wPOInput').value=r.so||r.po||'';
    document.getElementById('wMachineInput').value=currentWarrantyLabel||[r.m,r.s,r.t].filter(Boolean).join(' / ');
    document.getElementById('warrantyModal').classList.add('show');
    document.getElementById('warrantyModal').setAttribute('aria-hidden','false');
  }
  function closeWarranty(){
    document.getElementById('warrantyModal').classList.remove('show');
    document.getElementById('warrantyModal').setAttribute('aria-hidden','true');
  }
  function buildWarrantyPayload(formEl){
    const fd=new FormData(formEl), r=currentWarrantyRecord||{};
    const lines=[
      'WARRANTY_REGISTRATION_START',
      'Submitted From: Highlight Support Center',
      'Matched Machine: '+(currentWarrantyLabel||''),
      'Job Number: '+(r.job||''),
      'Sales Order: '+(r.so||''),
      'Machine Model: '+([r.m,r.s,r.t].filter(Boolean).join(' / ')),
      ''
    ];
    for(const [key,value] of fd.entries()) lines.push(key+': '+(value||''));
    lines.push('WARRANTY_REGISTRATION_END');
    return {subject:'Warranty Registration - '+(r.job||r.so||'Machine'),body:lines.join('\n')};
  }
  function buildWarrantyMailto(formEl){
    const payload=buildWarrantyPayload(formEl);
    return 'mailto:'+warrantyTo+'?subject='+encodeURIComponent(payload.subject)+'&body='+encodeURIComponent(payload.body);
  }
  function buildGmailComposeUrl(formEl){
    const payload=buildWarrantyPayload(formEl);
    const compose='https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent(warrantyTo)+'&su='+encodeURIComponent(payload.subject)+'&body='+encodeURIComponent(payload.body);
    return 'https://accounts.google.com/AccountChooser?continue='+encodeURIComponent(compose);
  }

  function buildSupportPayload(){
    const r=currentWarrantyRecord||{};
    const messageEl=document.getElementById('supportMessage');
    const message=messageEl ? messageEl.value : '';
    const machine=currentWarrantyLabel||'';
    const job=r.job||lastLookupKey||'';
    const so=r.so||'';
    const subject='Parts Support Request - '+(job||so||machine||'Machine');
    const lines=[
      'PARTS_SUPPORT_REQUEST_START',
      'Submitted From: Highlight Support Center',
      'Matched Machine: '+machine,
      'Job / Serial Number: '+job,
      'Sales Order: '+so,
      'Machine Model: '+([r.m,r.s,r.t].filter(Boolean).join(' / ')),
      '',
      'Message / Question: '+message,
      'PARTS_SUPPORT_REQUEST_END'
    ];
    return {subject,body:lines.join('\n')};
  }
  function buildSupportMailto(){
    const payload=buildSupportPayload();
    return 'mailto:parts@highlightindustries.com?subject='+encodeURIComponent(payload.subject)+'&body='+encodeURIComponent(payload.body);
  }
  function buildSupportGmailUrl(){
    const payload=buildSupportPayload();
    const compose='https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('parts@highlightindustries.com')+'&su='+encodeURIComponent(payload.subject)+'&body='+encodeURIComponent(payload.body);
    return 'https://accounts.google.com/AccountChooser?continue='+encodeURIComponent(compose);
  }
  function openSupportModal(){
    const r=currentWarrantyRecord||{};
    const supportMachine=document.getElementById('supportMachine');
    const supportJob=document.getElementById('supportJob');
    const supportSO=document.getElementById('supportSO');
    if(supportMachine) supportMachine.textContent=currentWarrantyLabel||'No machine match yet';
    if(supportJob) supportJob.textContent=r.job||lastLookupKey||'—';
    if(supportSO) supportSO.textContent=r.so||'—';
    const modal=document.getElementById('supportModal');
    if(modal){ modal.classList.add('show'); modal.setAttribute('aria-hidden','false'); }
  }
  function closeSupportModal(){
    const modal=document.getElementById('supportModal');
    if(modal){ modal.classList.remove('show'); modal.setAttribute('aria-hidden','true'); }
  }

  function render(r){
    const manual=matchManual(r), label=machineLabel(r);
    if(!manualRules.length){
      manual.title='Manual rules are not loading';
      manual.url='';
      manual.note='The machine record loaded, but the manual rules file did not load. Check that manual-rules.csv is uploaded and publicly reachable.';
      manual.status='warn';
    }
    currentWarrantyRecord=r; currentWarrantyLabel=label;
    const resultState=document.getElementById('resultState');
    let heading=document.getElementById('resultHeading');
    if(!heading){
      heading=document.createElement('div');
      heading.id='resultHeading';
      heading.className='result-heading';
      resultState.prepend(heading);
    }
    const isCSA=csaJobs.has(digits(r.job));
    heading.innerHTML=`<div><div class="eyebrow">${isCSA?'CSA/CUL machine found':'Machine found'}</div><h2>${label}</h2><p>Your matching support resources are ready below.</p></div><div class="result-chip">Job / Serial ${r.job||''}</div>`;
    const statusLine=document.getElementById('lookupStatus');
    if(statusLine){ statusLine.className='lookup-status found'; statusLine.textContent='Machine found — resources ready below.'; }
    document.getElementById('statusPill').className='status'+(manual.status==='warn'?' warn':'');
    document.getElementById('statusPill').textContent=manual.status==='warn'?'Support review needed':'Manual match found';
    document.getElementById('machineTitle').textContent=label;
    const noteEl=document.getElementById('ruleNote');
    noteEl.textContent=manual.note||'';
    noteEl.className='note'+(manual.status==='warn'?' warn':'');
    const meta=[
      ['Job / Serial',r.job||'—'],
      ['Sales Order',r.so||'—'],
      ['Model', [r.m,r.s,r.t].filter(Boolean).join(' / ')||'—'],
      ['Machine Date',r.d||'—'],
      ['CSA/CUL List', isCSA ? 'Yes' : 'No']
    ];
    document.getElementById('metaGrid').innerHTML=meta.map(([a,b])=>`<div class="meta-item"><span>${a}</span><strong>${b}</strong></div>`).join('');
    document.getElementById('manualTitle').textContent=manual.title;
    document.getElementById('manualCopy').textContent=manual.url ? 'Open the verified support document for this machine.' : 'No verified online manual matched this machine/date. Contact Parts Support for confirmation.';
    const manualLink=document.getElementById('manualLink');
    if(manual.url){ manualLink.href=manual.url; manualLink.classList.remove('hidden'); }
    else { manualLink.href='#support-request'; manualLink.classList.add('hidden'); }
    document.getElementById('supportLink').href='#support-request';
    const extras=document.getElementById('extras');
    extras.innerHTML=(manual.extras||[]).filter(x=>x.url).map(x=>`<a class="extra" href="${x.url}" target="_blank" rel="noopener"><strong>${x.title}</strong><small>${x.note||''}</small></a>`).join('');
    document.getElementById('stickyTitle').textContent=label;
    const stickyManual=document.getElementById('stickyManual');
    if(manual.url){ stickyManual.href=manual.url; stickyManual.classList.remove('hidden'); }
    else { stickyManual.href='#'; stickyManual.classList.add('hidden'); }
    show(result);
    if(sticky) sticky.classList.add('show');
    window.setTimeout(hiScrollToResultTop, 170);
  }

  function runLookup(e){
    if(e && e.preventDefault) e.preventDefault();
    const status=document.getElementById('lookupStatus');
    const key=digits(input && input.value);
    lastLookupKey=key;
    if(status){ status.className='lookup-status'; status.textContent=key ? 'Looking up '+key+'…' : 'Enter a serial number or PO number first.'; }
    if(!key){ show(empty); if(sticky) sticky.classList.remove('show'); return false; }

    beginLookup(()=>{
      loadData().then(()=>{
        if(csvLoadErrors.length || !manualRules.length){
          console.warn('Support Center CSV issue:', csvLoadErrors, 'manualRules:', manualRules.length);
        }
        const rec=findSupportRecord(key);
        if(rec){
          if(status){ status.className='lookup-status found'; status.textContent='Machine found — resources ready below.'; }
          render(rec);
        }else{
          if(status){ status.className='lookup-status'; status.textContent='No matching machine found.'; }
          document.getElementById('notFoundSupport').href='#support-request';
          show(notFound);
          window.setTimeout(()=>document.getElementById('notFoundState').scrollIntoView({behavior:'smooth',block:'start'}),170);
        }
      });
    });
    return false;
  }

  document.querySelectorAll('[data-close-warranty]').forEach(el=>el.addEventListener('click',closeWarranty));
  const warrantyForm=document.getElementById('warrantyEmailForm');
  if(warrantyForm){
    warrantyForm.addEventListener('submit',e=>{
      e.preventDefault();
      window.location.href=buildWarrantyMailto(e.currentTarget);
    });
  }
  const gmailBtn=document.getElementById('openGmailDraft');
  if(gmailBtn){
    gmailBtn.addEventListener('click',()=>{
      const formEl=document.getElementById('warrantyEmailForm');
      window.open(buildGmailComposeUrl(formEl),'_blank','noopener');
    });
  }
  const copyBtn=document.getElementById('copyWarrantyDetails');
  if(copyBtn){
    copyBtn.addEventListener('click',async()=>{
      const payload=buildWarrantyPayload(document.getElementById('warrantyEmailForm'));
      const status=document.getElementById('copyWarrantyStatus');
      try{
        await navigator.clipboard.writeText('To: '+warrantyTo+'\nSubject: '+payload.subject+'\n\n'+payload.body);
        if(status) status.textContent='Warranty details copied. Paste them into any email account.';
      }catch(err){
        if(status) status.textContent='Copy did not work in this browser. You can still open Gmail or your email app.';
      }
    });
  }
  const warrantyLink=document.getElementById('warrantyLink');
  if(warrantyLink){
    warrantyLink.addEventListener('click',e=>{ e.preventDefault(); openWarranty(); });
  }

  document.querySelectorAll('[data-close-support]').forEach(el=>el.addEventListener('click',closeSupportModal));
  const supportLinkEl=document.getElementById('supportLink');
  if(supportLinkEl){ supportLinkEl.addEventListener('click',e=>{ e.preventDefault(); openSupportModal(); }); }
  const notFoundSupportEl=document.getElementById('notFoundSupport');
  if(notFoundSupportEl){ notFoundSupportEl.addEventListener('click',e=>{ e.preventDefault(); openSupportModal(); }); }
  const supportEmailBtn=document.getElementById('openSupportEmailApp');
  if(supportEmailBtn){ supportEmailBtn.addEventListener('click',()=>{ window.location.href=buildSupportMailto(); }); }
  const supportGmailBtn=document.getElementById('openSupportGmail');
  if(supportGmailBtn){ supportGmailBtn.addEventListener('click',()=>{ window.open(buildSupportGmailUrl(),'_blank','noopener'); }); }
  const copySupportBtn=document.getElementById('copySupportDetails');
  if(copySupportBtn){
    copySupportBtn.addEventListener('click',async()=>{
      const payload=buildSupportPayload();
      const status=document.getElementById('copySupportStatus');
      try{
        await navigator.clipboard.writeText('To: parts@highlightindustries.com\nSubject: '+payload.subject+'\n\n'+payload.body);
        if(status) status.textContent='Support details copied. Paste them into any email account.';
      }catch(err){
        if(status) status.textContent='Copy did not work in this browser. You can still open Gmail or your email app.';
      }
    });
  }

  if(form) form.addEventListener('submit',runLookup);
  const button=document.getElementById('lookupButton');
  if(button) button.addEventListener('click',runLookup);
  window.runSupportLookup=runLookup;

  loadData();

})();
